import {NavLink, Link} from "react-router-dom";
import './Header.css';

export default function Header () {
  return (
    <header>
        <div class="main_title">
            <h1 class="siteTitle"><Link to="/">MEMORY LANE GAMES</Link> </h1> 
        </div> 
        <nav class="homeMenu"> 
            <ul className='menu_list'>
                <li class="nav"><NavLink to="/">Accueil</NavLink></li>
                {/* <li class="nav"><NavLink to="/a-propos">A propos</NavLink></li> */}
            </ul>
        </nav>    
    </header>
  );
}

